import React, { FC } from 'react';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { FiInfo } from 'react-icons/fi';
import { ReactComponent as UnknowSvg } from 'assets/unknowType.svg';
import { checkedLocalization } from 'utils/checkedLocalization';
import css from '../styles.module.scss';

interface IUploadItemProps {
  number: number;
  name?: string;
  error?: string | null;
  icon: string | null;
  isIconLoaded: boolean;
}

const UploadItem: FC<IUploadItemProps> = ({ number, name, error, icon,isIconLoaded }) => (
  <div className={css.item}>
    <div className={css.item_info}>
      <div className={css.item_number}>{number}</div>
      {isIconLoaded && icon && <div className={css.item_icon}><img src={icon} alt={name}/></div>}
      {isIconLoaded && !icon && <div className={css.item_icon}><UnknowSvg /></div>}
      <div className={css.item_name} title={name}>
        {name}
      </div>
    </div>
    {error && (
      <>
        <TooltipPoratal hint={checkedLocalization(`${error}`, error)} white classname={css.item_hint}>
          <FiInfo size={20} />
        </TooltipPoratal>
      </>
    )}
  </div>
);

export default UploadItem;
